export default {
  FORM_OPEN: 'autoVerify_formOpen',
  FORM_START: 'autoVerify_formStart',
  FORM_COMPLETE: 'autoVerify_formComplete',
  LEAD_COMPLETE: 'autoVerify_leadComplete',
  CTA_INTERACTION: 'autoVerify_ctaInteraction',
  FORM_ENGAGEMENT: 'autoVerify_formEngagement',
};
